import React from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';

import AppointmentBox from '../../../components/AppointmentBox/AppointmentBox';
import classes from './AppointmentHistory.css';

class AppointmentHistory extends React.Component{

    componentDidMount() {
        if (this.props.isAuthenticated === true) {
            this.props.getAppointmentHistory();
        }
        else {
            setTimeout(
                () => {
                    this.props.getAppointmentHistory();
                },
                100
            )
        }
        window.scrollTo(0, 0);
    }

    render(){

        let content;
        if (this.props.appointments === undefined || this.props.appointments.length <= 0){
            content = <Col> You currently do not have any appointment </Col>
        }
        else {
            content = 
                this.props.appointments.map((appointment, index) => (

                    <Col lg={4} key={index}>
                    <AppointmentBox 
                        appointment_id={appointment.id}
                        firstName={appointment.first_name}
                        lastName={appointment.last_name}
                        email={appointment.email} 
                        id={appointment.id}
                        info={appointment.info} 
                        time={appointment.due_date}
                        role={appointment.role}
                        host={appointment.host}
                        guest={appointment.guest}
                        contact_method={appointment.contact_method}
                        key={index}
                        isMobile={this.props.isMobile}>
                    </AppointmentBox>
                    </Col>
                ));
        }

        return (

            <div>
            <Helmet>
            <title>Appointment History | BookMeeY</title>
            <meta name="description" content="Viewing all your past appointments" />
            </Helmet>

            <Container>
                <Card bsPrefix={classes.CardBody}>
                <Card.Header><b>Past Appointments</b></Card.Header>
                <Card.Body>
                    <Row>
                        { content }
                    </Row>
                </Card.Body>
                </Card>
            </Container>

            <Route path="/relation/history"/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        appointments: state.appointmentHistory.appointments,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAppointmentHistory: () => dispatch( actions.appointmentHistoryGet() ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (AppointmentHistory);


// WEBPACK FOOTER //
// ./src/containers/RelationManagement/AppointmentHistory/AppointmentHistory.js